import React, { Component } from 'react';
import { Button, ButtonType, Spinner } from '@riotgames/accounts-react-components';
import AppContext from '../../AppContext';

import cx from 'classnames';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';
import BanStatus from '../../comps/BanStatus';

class CheckAccount extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      shouldWaitForCheckAccount: true
    };

    this.moveNext = this.moveNext.bind(this);
  }

  update(params) {
    const { actions } = this.context;
    actions.setData(params);
  }

  async componentDidMount() {
    const {
      actions: { getAccountList }
    } = this.context;

    try {
      this.setState({ shouldWaitForCheckAccount: true });
      const { data } = await getAccountList();
      const { accountsList, moreAccountsAllowed, gameRestricted } = data;
      const existingAccounts = accountsList
        .map((acc) => ({
          userName: acc.userName,
          createdDate: acc.createdDate,
          accountState: acc.accountState
        }))
        .filter((acc) => acc.accountState !== 'BANNED');
      this.setState({ shouldWaitForCheckAccount: false });

      this.update({
        existingAccounts,
        moreAccountsAllowed,
        gameRestricted
      });

      if (!gameRestricted) {
        this.moveNext();
      }
    } catch (e) {
      this.update({
        hasError: true,
        shouldReset: true,
        errorHeader: '안내',
        errorDetail: '올바른 접근이 아니거나 입력 시간이 초과되었습니다.'
      });
    }
  }

  moveNext() {
    this.props.handleMoveNext();
  }

  render() {
    const { shouldWaitForCheckAccount } = this.state;
    const {
      state: { gameRestricted }
    } = this.context;

    const titleOfBanNotification = gameRestricted && '영구 이용제한 내역 알림';
    const titleGridPanel = shouldWaitForCheckAccount ? '라이엇 계정 확인중...' : titleOfBanNotification;
    const subTitleGridPanel = gameRestricted && (
      <p className="help-text">
        영구 게임 이용제한 조치를 받은 이력이 있습니다. 새로운 라이엇 계정을 생성하여도 아래의 게임은 이용 하실 수
        없습니다.
      </p>
    );

    return (
      <GridPanel
        title={titleGridPanel}
        subTitle={subTitleGridPanel}
        button={!shouldWaitForCheckAccount && <Button buttonType={ButtonType.submit} onClick={this.moveNext} />}
      >
        <Grid
          direction={GridDirection.vertical}
          align={GridAlignment.center}
          justify={GridJustify.spaceBetween}
          fill={true}
        >
          {shouldWaitForCheckAccount && <Spinner />}
          {!shouldWaitForCheckAccount && gameRestricted && (
            <BanStatus
            // gameList={gameRestricted.gameList} // Todo: fix this after BE ready
            />
          )}
        </Grid>
      </GridPanel>
    );
  }
}

export default CheckAccount;
